<template>
  <div class="main">
    <el-upload
      class="upload-resume"
      drag
      :action="url_Api + '/hr24_user/v1/upload_file/'"
      multiple
      :on-success="file_success"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        将Excel文件拖到此处，或
        <em>点击上传</em>
      </div>
      <div class="el-upload__tip" slot="tip">
        只能上传 Excel 文件，且不超过10MB
      </div>
    </el-upload>

    <!-- 表格 -->
    <div class="log_table">
      <div class="log_title">导入简历记录</div>
      <el-table :data="tableData" stripe style="width: 100%;font-size:14px">
        <el-table-column
          prop="file_date"
          label="日期"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="file_status"
          label="状态"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="total_num"
          label="总条数"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="valid_num"
          label="有效数"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="useless_num"
          label="无效数"
          width="180"
        ></el-table-column>
        <el-table-column prop="file_name" label="文件名"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { require, url_Api } from "@/utils/http_request.js";
export default {
  data() {
    return {
      url_Api: "",
      tableData: []
    };
  },

  created() {
    this.url_Api = url_Api;
    let obj = {
      //   token: this.$cookies.get("token")
    };
    require("post", "/hr24_resume/v1/resume_list/", obj).then(res => {
      if (!res.code) {
        this.tableData = res.data.reverse();
      } else {
      }
    });
  },

  methods: {
    file_success(e) {
      console.log(e, "22222");
      let obj = {
        token: this.$cookies.get("token"),
        file_url: e.data.file_data.file_url,
        file_id: e.data.file_data.file_id,
        file_name: e.data.file_name
      };

      require("post", "/hr24_resume/v1/resume_log/", obj).then(res => {
        if (!res.code) {
          this.$message({
            message: "上传文件成功，请不要重复提交",
            type: "success"
          });

          // 隐藏加载，跳转到首页
          this.is_loading = false;
        } else {
          this.$message.error(res.msg);
          this.is_loading = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.log_title {
  padding: 20px 20px 20px 10px;
  color: #606266;
  font-weight: 600;
}
.log_table {
  height: 55vh;
  width: 53vw;
  float: right;
  position: relative;
  top: -270px;
  right: 60px;
  overflow-y: auto;
}
.el-upload__tip {
  font-size: 12px;
  color: #606266;
  margin-top: 20px;
  margin-left: 0px;
}

.el-upload__text {
  padding-left: 10px;
}

.upload-resume {
  padding: 30px 30px 30px 50px;
  /* background: red; */
}
</style>



// WEBPACK FOOTER //
// src/user_management/import_resume.vue